// Copyright (c) StrangeBee 2024

import THTag from '@Atoms/THTag/THTag';
import { HTMLColors } from '@Constants/colors';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement, useContext, useMemo } from 'react';
import { CaseCustomField } from 'thehive-sdk';
import { useFormatDate } from '@Hooks/useFormatDate';
import { ScopeContext } from '@Context/ScopeProvider';
import { CustomFieldOutput } from 'thehive-sdk';

import './CustomFieldTag.scss';

interface CustomFieldTagProps {
    customField: CaseCustomField;
    onClick?: () => void;
}

const libDisplayName = new Map();

const useDisplayName = (techName = '', customFieldList: CustomFieldOutput[]): string => {
    return useMemo(() => {
        if (!libDisplayName.has(techName)) {
            const cf = customFieldList.find(({ name }) => name === techName);
            libDisplayName.set(techName, cf?.displayName || name);
        }

        return libDisplayName.get(techName);
    }, [customFieldList, techName]);
};

export const CustomFieldTag = ({ customField, onClick }: CustomFieldTagProps): ReactElement => {
    const f = useFormatDate();
    let valueProcessed = '-';

    const { customFieldList } = useContext(ScopeContext);
    const { description = '', name = '', value, type } = customField;
    const displayName = useDisplayName(name, customFieldList);
    if (value !== null && value !== undefined) {
        valueProcessed = type === 'date' ? f(value as number) : value + '';
    }

    return (
        <span className="custom-field-tag">
            <THTooltip title={description} placement="bottom">
                <span>
                    <THTag value={displayName} color={HTMLColors.BLUE} borderProps="0.25rem solid" onClick={onClick} />
                </span>
            </THTooltip>
            <THTooltip title={type} placement="bottom">
                <span>
                    <THTag
                        value={valueProcessed}
                        color={HTMLColors.BLUE}
                        borderProps="2px dotted"
                        combined
                        onClick={onClick}
                    />
                </span>
            </THTooltip>
        </span>
    );
};
